<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-also-by element-with-heading full-character-formatting" id="also-by">
<div class="heading heading-with-title heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title case-mixed">Books in the Order of the Dragon Series</h1>
</div>
</div>
</div>
</div>
<div class="text" id="also-by-text">
<p class="first first-in-chapter first-full-width also-by-content"><span class="underline">Main Books</span></p>
<p class="subsq also-by-content"><i>All of the main stories have numbers in the title</i></p>
<p class="subsq also-by-content"><a class="content-external-link" href="https://books2read.com/u/bw21nY" target="_blank">Zero Hour: Prequel Story</a></p>
<p class="subsq also-by-content"><a class="content-external-link" href="https://books2read.com/u/3GxRla" target="_blank">Once Bitten</a></p>
<p class="subsq also-by-content"><a class="content-external-link" href="https://books2read.com/u/brVo6Y" target="_blank">Twice as High</a></p>
<p class="subsq also-by-content"><a class="content-external-link" href="https://books2read.com/3littlewords" target="_blank">Three Little Words</a></p>
<p class="subsq also-by-content"><a class="content-external-link" href="https://books2read.com/u/49kq1W" target="_blank">Four Times the Fight</a></p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width also-by-content"><span class="underline">Side Stories</span></p>
<p class="subsq also-by-content"><a class="content-external-link" href="https://books2read.com/u/m0OvOW" target="_blank">Charming Like A Wolf</a></p>
<p class="subsq also-by-content"><a class="content-external-link" href="https://books2read.com/u/4DgXgO" target="_blank">A Vampire Gives No Quarter</a></p>
<p class="subsq also-by-content"><a class="content-external-link" href="https://books2read.com/u/4DRVEe" target="_blank">Bite Me: A Vampire Night</a></p>
<p class="subsq also-by-content"><a class="content-external-link" href="https://books2read.com/u/4XDK21" target="_blank">A Half-Cocked Vampire</a></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// booksintheorderofthedragonseries.vue?080d072c